/**
 * Stilenza Quick Add — kies je maat en kleur zonder de pagina te verlaten.
 *
 * Elk element met data-stil-qa-open="<producthandle>" opent het paneel. De
 * inhoud komt van de Section Rendering API:
 *
 *     /products/<handle>?section_id=stilenza-quick-add-panel
 *
 * Dus geen nagebouwde kaart: het is dezelfde Liquid als de productpagina. De
 * kleurstalen, de prijsopmaak van de markt en de vertalingen komen daardoor
 * vanzelf goed, zonder dat deze code daar iets van hoeft te weten.
 *
 * Waarom dit bestaat: de aanbevelingen in de winkelwagenlade legden blind
 * variants[0] in de wagen. Bij een jurk met maten kreeg de klant XS, wat hij
 * ook wilde — en dat merkte hij pas bij de bezorging.
 */
(function () {
  'use strict';

  var root = document.getElementById('stil-quick-add');
  if (!root) return;

  var cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('stil-quick-add-config').textContent);
  } catch (e) {
    cfg = {};
  }

  // routes.root_url geeft "/fr-fr" zonder slash, en "/" op de hoofdmarkt.
  // Zonder deze normalisatie wordt de URL "/fr-frproducts/...".
  var ROOT = (cfg.root || '/').replace(/\/*$/, '/');
  var SECTION = 'stilenza-quick-add-panel';

  var body = root.querySelector('[data-qa-body]');
  var opener = null; // knop waar we vandaan kwamen, voor focus-herstel
  var variants = [];
  var chosen = {}; // positie -> waarde
  var qty = 1;
  var shownMedia = null;
  var cache = {};

  function text(key) {
    // Liquid heeft deze teksten al ge-escaped; nog een keer zou &#39; opleveren.
    return Object.prototype.hasOwnProperty.call(cfg.strings || {}, key) ? cfg.strings[key] : '';
  }

  /* ── Ophalen ───────────────────────────────────────────────────────── */
  function fetchPanel(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION)
      .then(function (r) {
        if (!r.ok) throw new Error('niet gevonden');
        return r.text();
      })
      .then(function (html) {
        cache[handle] = html;
        return html;
      });
  }

  /* ── Openen en sluiten ─────────────────────────────────────────────── */
  function open(handle, button) {
    opener = button || null;
    root.hidden = false;
    document.body.classList.add('stil-qa-open');
    body.innerHTML = '<p class="stil-qa__message">' + text('loading') + '</p>';
    requestAnimationFrame(function () { root.classList.add('is-open'); });

    fetchPanel(handle)
      .then(function (html) {
        // De sectie komt als hele pagina terug; we willen alleen het product.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var piece = doc.querySelector('.stil-qa__product');
        if (!piece) throw new Error('geen paneelinhoud');
        body.innerHTML = '';
        body.appendChild(piece);
        afterInsert();
      })
      .catch(function () {
        body.innerHTML = '<p class="stil-qa__message">' + text('load_error') + '</p>';
      });
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('stil-qa-open');
    // pas verbergen als de overgang klaar is, anders springt hij weg
    setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 240);
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  /* ── Varianten ─────────────────────────────────────────────────────── */
  function afterInsert() {
    var json = body.querySelector('[data-qa-variants]');
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      variants = [];
    }

    chosen = {};
    qty = 1;
    shownMedia = null;
    body.querySelectorAll('.stil-qa__value.is-chosen').forEach(function (b) {
      chosen[b.getAttribute('data-qa-position')] = b.getAttribute('data-qa-value');
    });

    // Een optie met maar één waarde staat niet in de markup; die halen we uit
    // de eerste variant, anders vindt de vergelijking nooit een combinatie.
    if (variants.length && variants[0].options) {
      variants[0].options.forEach(function (value, i) {
        var position = String(i + 1);
        if (!body.querySelector('[data-qa-option="' + position + '"]')) {
          chosen[position] = value;
        }
      });
    }
    refresh();
  }

  function current() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var hit = true;
      for (var k = 0; k < v.options.length; k++) {
        if (chosen[String(k + 1)] !== v.options[k]) { hit = false; break; }
      }
      if (hit) return v;
    }
    return null;
  }

  function refresh() {
    var button = body.querySelector('[data-qa-add]');
    if (!button) return;
    var label = button.querySelector('[data-qa-addlabel]');
    var v = current();

    // Alles gekozen? Zo niet, dan vragen we daar eerst om in plaats van een
    // willekeurige variant toe te voegen — dat was precies de fout die dit
    // paneel moest oplossen.
    var groups = body.querySelectorAll('[data-qa-option]');
    var done = 0;
    groups.forEach(function (g) {
      if (chosen[g.getAttribute('data-qa-option')]) done++;
    });

    if (done < groups.length) {
      button.disabled = true;
      if (label) label.textContent = text('select_options');
    } else if (!v || !v.available) {
      button.disabled = true;
      if (label) label.textContent = text('sold_out');
    } else {
      button.disabled = false;
      if (label) label.textContent = text('add_to_cart');
      button.setAttribute('data-qa-variant', v.id);
    }

    if (v) {
      var price = body.querySelector('[data-qa-price]');
      var was = body.querySelector('[data-qa-was]');
      var badge = body.querySelector('[data-qa-badge]');
      var stock = body.querySelector('[data-qa-stock]');
      var stockText = body.querySelector('[data-qa-stocktext]');
      if (price) price.textContent = v.price;
      if (was) {
        if (v.was) { was.textContent = v.was; was.hidden = false; }
        else { was.hidden = true; }
      }
      // Het percentage komt kant-en-klaar uit Liquid mee: "-23%" is Europees,
      // in Japan is "23%OFF" de standaard. Die keuze hoort in locales, niet hier.
      if (badge) {
        if (v.badge) { badge.textContent = v.badge; badge.hidden = false; }
        else { badge.hidden = true; }
      }
      // Alleen uitverkocht meldt zich. "In stock" stond bij elke variant en
      // zei daarmee niets; de regel hangt nu verborgen tot hij iets te zeggen
      // heeft.
      if (stock && stockText) {
        stock.hidden = !!v.available;
        stockText.textContent = stock.getAttribute('data-out') || '';
      }
      // De strook springt naar de foto van deze variant. Alleen als hij
      // verandert, anders schuift hij bij elke klik opnieuw.
      if (v.media) showMedia(v.media);
    }

    // Kleurnaam naast het label bijwerken
    body.querySelectorAll('[data-qa-chosen]').forEach(function (el) {
      var value = chosen[el.getAttribute('data-qa-chosen')];
      if (value) el.textContent = value;
    });

    // Combinaties die niet meer te krijgen zijn doorstrepen in plaats van
    // verbergen: dan ziet iemand dat de maat bestaat maar op is.
    body.querySelectorAll('.stil-qa__value').forEach(function (b) {
      var position = b.getAttribute('data-qa-position');
      var probe = {};
      for (var k in chosen) probe[k] = chosen[k];
      probe[position] = b.getAttribute('data-qa-value');
      var possible = variants.some(function (x) {
        for (var i = 0; i < x.options.length; i++) {
          var p = String(i + 1);
          if (probe[p] && probe[p] !== x.options[i]) return false;
        }
        return x.available;
      });
      b.classList.toggle('is-soldout', !possible);
    });
  }

  function showMedia(id) {
    if (String(id) === String(shownMedia)) return;
    var strip = body.querySelector('[data-qa-media]');
    var target = body.querySelector('[data-qa-media-id="' + id + '"]');
    if (!strip || !target) return;
    strip.scrollTo({ left: target.offsetLeft - strip.offsetLeft, behavior: 'smooth' });
    shownMedia = id;
  }

  function setQty(next) {
    qty = Math.max(1, Math.min(99, next));
    var el = body.querySelector('[data-qa-qty]');
    if (el) el.textContent = qty;
  }

  /* ── Toevoegen ─────────────────────────────────────────────────────── */
  function addToCart(button) {
    var id = button.getAttribute('data-qa-variant');
    if (!id) return;
    var label = button.querySelector('[data-qa-addlabel]');
    button.disabled = true;
    if (label) label.textContent = text('adding');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('mislukt');
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = text('added');
        // De lade ververst zichzelf; die functie zet ook het aantal bij.
        if (typeof window.stilRefreshCartDrawer === 'function') window.stilRefreshCartDrawer();
        setTimeout(close, 700);
      })
      .catch(function () {
        button.disabled = false;
        if (label) label.textContent = text('add_error');
      });
  }

  /* ── Luisteren ─────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-stil-qa-open]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open(trigger.getAttribute('data-stil-qa-open'), trigger);
      return;
    }
    if (e.target.closest('[data-qa-close]')) { close(); return; }

    var value = e.target.closest('.stil-qa__value');
    if (value && root.contains(value)) {
      if (value.classList.contains('is-soldout')) return;
      var position = value.getAttribute('data-qa-position');
      chosen[position] = value.getAttribute('data-qa-value');
      body.querySelectorAll('[data-qa-position="' + position + '"]').forEach(function (b) {
        b.classList.toggle('is-chosen', b === value);
      });
      refresh();
      return;
    }

    if (e.target.closest('[data-qa-minus]')) { setQty(qty - 1); return; }
    if (e.target.closest('[data-qa-plus]')) { setQty(qty + 1); return; }

    var add = e.target.closest('[data-qa-add]');
    if (add && root.contains(add) && !add.disabled) addToCart(add);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
})();
